<template>
    <modal :title="setModel!=undefined?'Update Software':'Add Software'" @close="$emit('close')">
        <template #content>
            <Form method="dialog" v-slot="{ errors }" class="floating-labels p-1rem" ref="form">
                <formGroup :title="'Name'" v-model="model.Name" :errors="errors" :rules="{required:true,max:50}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P1Name'" v-model="model.P1Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P2Name'" v-model="model.P2Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P3Name'" v-model="model.P3Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P4Name'" v-model="model.P4Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'P5Name'" v-model="model.P5Name" :errors="errors" :rules="{max:100}" @keydown.enter="save"></formGroup>
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :process="process">{{setModel!=undefined?'Update Software':'Add Software'}}</Btn>
        </template>
    </modal>
</template>

<script>
    export default {
        props:{
            setModel:Object
        },
        data(){
            return{
                model:{
                    Id: null,
                    Name: "",
                    P1Name: "",
                    P2Name: "",
                    P3Name: "",
                    P4Name: "",
                    P5Name: ""
                },
                errs:{

                },
                process:false
            }
        },
        created(){
            if(this.setModel!=undefined){
                this.model={...this.setModel};
            }
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.put(`Softwares`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:this.setModel!=undefined?"The software has been successfully updated.":"The software has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            if(this.setModel!=undefined){
                                this.$emit("update",response.data);
                            }else{
                                this.$emit("add",response.data);
                            }
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>